var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7361 1.95165C9.16639 -0.650549 4.9995 -0.650549 2.42975 1.95165C-0.14325 4.55055 -0.14325 8.76801 2.42975 11.3669L7.08132 16.0746L11.7361 11.3669C14.3059 8.76801 14.3059 4.55384 11.7361 1.95165Z",
    fill: "#FBDB00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0731 1.95308C18.5033 -0.64582 14.3364 -0.64582 11.7667 1.95308C9.19366 4.55199 9.19366 8.76945 11.7667 11.3684L16.4182 16.076L21.0731 11.3684C23.6428 8.76945 23.6428 4.55528 21.0731 1.95308Z",
    fill: "#7CC14B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.4153 6.68355C13.8456 4.08465 9.6787 4.08465 7.10895 6.68355C4.5392 9.28246 4.5392 13.4966 7.10895 16.0955L11.7638 20.8032L16.4186 16.0955C18.9883 13.4966 18.9883 9.28246 16.4186 6.68355",
    fill: "#19B3B5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4bb4200a1c0fbe040647596d0094c8b5.svg";
export { ForwardRef as ReactComponent };